module.exports = __webpack_public_path__ + "img/edit-2.8773c50c.svg";